import {LogLevel} from '../log-level';
import {LogMessage} from '../log-message';

/**
 * Abstract logger appender
 */
export abstract class LoggerAppender {
  public abstract log(message: LogMessage, level: LogLevel, args: any[], history: LogMessage[]): void;
}
